module.exports = __webpack_public_path__ + "static/media/gloves.9188e5a2.jpg";